import { RiNextjsFill } from "react-icons/ri";
import {
  SiCss3,
  SiFirebase,
  SiHtml5,
  SiReact,
  SiTypescript,
} from "react-icons/si";
import styled from "styled-components";

export default function TwitterTechIcons() {
  return (
    <IconsContainer>
      <IconWrapper>
        <SiHtml5 />
        <Tooltip>HTML5</Tooltip>
      </IconWrapper>
      <IconWrapper>
        <SiCss3 />
        <Tooltip>CSS3</Tooltip>
      </IconWrapper>
      <IconWrapper>
        <SiTypescript />
        <Tooltip>TypeScript</Tooltip>
      </IconWrapper>
      <IconWrapper>
        <SiFirebase />
        <Tooltip>Firebase</Tooltip>
      </IconWrapper>
      <IconWrapper>
        <SiReact />
        <Tooltip>React</Tooltip>
      </IconWrapper>
      <IconWrapper>
        <RiNextjsFill />
        <Tooltip>Next.js</Tooltip>
      </IconWrapper>
    </IconsContainer>
  );
}

const IconsContainer = styled.div`
  display: flex;
  width: auto;
  height: auto;
  font-size: 1.4rem;
  gap: 10px;
  margin: 10px 0px;
  align-items: center; /* Ensures all icons are vertically centered */
`;

const IconWrapper = styled.div`
  position: relative;
  display: inline-block;
  cursor: pointer;

  &:hover span {
    visibility: visible;
    opacity: 1;
  }
`;

const Tooltip = styled.span`
  visibility: hidden;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 10px;
  position: absolute;
  z-index: 1;
  bottom: 150%; /* Position above the icon */
  left: 50%;
  transform: translateX(-50%); /* Center the tooltip */
  opacity: 0;
  transition: opacity 0.3s;
  font-size: 0.75rem;
  white-space: nowrap;

  &::after {
    content: "";
    position: absolute;
    top: 100%; /* Arrow at the bottom of the tooltip */
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: black transparent transparent transparent;
  }
`;
